/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Kazo 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Birenga": ["Gahondo", "Karisizo", "Murindwa", "Murusenyi", "Nyakagezi"],
  "Gahurire": ["Itambiro", "Rebero", "Rugenge", "Umuyange"],
  "Karama": ["Kabimba", "Kagusa", "Karenge", "Mpandu", "Rango"],
  "Kinyonzo": ["Amabumba", "Kibimba", "Rugarama", "Tunduti"],
  "Umukamba": ["Akabaya", "Kagarama", "Kazo", "Umukamba"]
};